import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { IndexedService, SYSTEM2DS_STORE } from '@damofire/data-commons';
import { System2d } from '../../asset/asset.dto';
import { FirebaseSystemDrawingService } from '../../system/firebase-system.service';
import { RemoteService } from './remote.service';

@Injectable()
export class SystemRemoteService extends RemoteService<System2d> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseSystemService: FirebaseSystemDrawingService,
  ) {
    super(SYSTEM2DS_STORE, idbService, networkService);
  }

  async add(division: string, data: System2d[]): Promise<void> {
    await this.firebaseSystemService.create(division, data);
  }

  async delete(division: string, data: System2d[]): Promise<void> {
    await this.firebaseSystemService.delete(division, data);
  }

  async update(division: string, data: System2d[]): Promise<void> {
    await this.firebaseSystemService.update(division, data);
  }
}
